import { store } from './store';
import authActions from './auth/actions';

export default () =>
  new Promise(() => {
    store.dispatch(authActions.checkAuthorization());
  });



// WEBPACK FOOTER //
// ./src/redux/boot.js